export const COLORS = {
  ["web-background"]: "#dbf9ff",
  ["white"]: "white",
  ["light-white"]: "rgb(255 255 255 / 10%)",
  ["light-white-2"]: "rgb(255 255 255 / 93%)",
  ["light-white-3"]: "rgb(255 255 255 / 60%)",
  ["grey"]: "#68686f",
  ["text-grey"]: "#707070",
  ["light-grey"]: "#d9d9d9",
  ["light-grey-2"]: "#ddd",
  ["sidebar-background"]: "rgb(255 255 255 / 80%)",
  ["blue"]: "#065bf9",
  ["blue-2"]: "#00b4d8",
  ["mui-blue"]: "#1976d2",
  ["turquoise"]: "#c2fbec",
  ["light-turquoise"]: "#beeef6",
  ["border-color"]: "rgb(0 0 0 / 23%)",
  ["container-background"]: "#fafafa",
  ["dark-blue-1"]: "#1c2e9d",
  ["dark-blue-2"]: "#05204c",
  ["green-1"]: "#18cd4e7b",
  ["green-2"]: "#29bd29",
  red: "red",
  ["red-2"]: "#e90d0d",
  ["dark-red"]: "#cb3215",
  black: "black",
  ["black-2"]: "#333",
  ["light-border"]: "#e4e4e4",
  ["table-checkbox-border"]: "#c4bfbf",
  orange: "orange",
  ["box-shadow"]: "#0003",
  ["light-grey-3"]: "#f3f3f3",
  ["light-grey-4"]: "#e8e6e6",
  ["light-yellow"]: "#fef0da",
  ["light-green"]: "#d1f8ed",
  ["light-pink"]: "#fcdde4",
  ["light-blue"]: "#00b4d8",
  ["application-background"]: "#fafbfc",
  ["background-grey"]: "#05204c0a",
  ["lighter-grey"]: "#d6dce6",
  ["sky-blue"]: "#007bfc",
  ["dark-blue"]: "#1c2e9d",
  ["light-black"]: "#1c1b1b",
  ["black-text"]: "#000000c2",
  ["purple"]: "#9747ffa4",
  ["bright-green"]: "#2fac3c",
  ["user-green"]: "#29bd29",
  ["light-red"]: "#b52929",
  ["cancel-red"]: "#e90d0d",
  ["one-team"]: "#c4bfbf",
  ["notification-red"]: "#ed6161",
  ["notification-green"]: "#11ad3c",
  ["notification-purple"]: "#5856d6",
  ["notification-grey"]: "#616163",
  ["request-status-red"]: "#ea8080",
  ["request-status-orange"]: "#ee923d",
  ["request-status-green"]: "#7dd0a8",
  ["request-status-icons-blue"]: "#096df5",
  ["approve-green"]: "#17b130",
  ["deny-red"]: "#c83e3e",
  ["toggle-gray"]: "#e6e6e6",
  ["dark-skills-blue"]: "#03449e",
  ["splash-back"]: "#05204cf5",
  ["splash-dark"]: "#05204cd5",
  ["splash-light"]: "#00b4d829",
  ["grey-color"]: "#707070",
  ["main-color"]: "#05204c",
  ["description-text"]: "#757575",
  ["link-text"]: "#00b4d8",
  ["error-border"]: "#d32f2f",
  ["height-without-footer"]: "92.3vh",
};
